"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconsBell = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var IconsBell = function IconsBell(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.825 13.934l-.725-.689.725.689zM8 9a4 4 0 014-4V3a6 6 0 00-6 6h2zm0 2.756V9H6v2.756h2zM6 16c0-.534.208-1.018.55-1.377L5.1 13.245A3.99 3.99 0 004 16h2zm1 0H6v2h1v-2zm10 0H7v2h10v-2zm1 0h-1v2h1v-2zm-.55-1.377c.342.36.55.843.55 1.377h2a3.99 3.99 0 00-1.1-2.755l-1.45 1.378zM16 9v2.756h2V9h-2zm-4-4a4 4 0 014 4h2a6 6 0 00-6-6v2zm6.9 8.245c-.608-.64-.9-1.087-.9-1.489h-2c0 1.294.89 2.278 1.45 2.867l1.45-1.378zM4 16a2 2 0 002 2v-2H4zm14 2a2 2 0 002-2h-2v2zM6 11.756c0 .402-.292.85-.9 1.49l1.45 1.377C7.11 14.033 8 13.05 8 11.756H6z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.798 19.877a2 2 0 01-3.62-.05M12 3v1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports.IconsBell = IconsBell;